<template>
  <hm-content title="">
    <div class="table-panel flex flex-between mb30">
      <div class="flex item-center">
        <div>
          排名项目：
          <el-radio-group
            v-model="searchCondition.ruleTimeStrategyType"
            class="margin-right"
            size="small"
          >
            <el-radio label="shangPin">商品</el-radio>
            <el-radio label="pinPai">品牌</el-radio>
            <el-radio label="huiYuan">会员</el-radio>
            <el-radio label="tuiHuiYuan">推会员</el-radio>
            <el-radio label="menDian">门店</el-radio>
            <el-radio label="daoGou">导购</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>

    <div class="table-panel flex flex-start  mb20">
      <div class="flex item-center">
        <div>
          查询条件：
          <el-date-picker
            v-model="searchCondition.applyDate"
            type="datetimerange"
            align="right"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始时间段筛选"
            end-placeholder="结束时间段筛选"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="mr10"
            clearable
          ></el-date-picker>
        </div>
      </div>
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="search"
          >生成报表</el-button
        >
      </div>
      <div>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div
      class="table"
      v-if="searchCondition.ruleTimeStrategyType === 'shangPin'"
    >
      <el-table
        ref="table"
        :data="spuRank.records"
        style="width: 100%"
        stripe
        size="small"
        border
        @sort-change="sortChange"
        :default-sort="{ prop: 'num', order: 'descending' }"
        @selection-change="getChecked"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="商品"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          label="品牌"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="saleNum"
          label="售卖数"
          sortable
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="saleMoney"
          sortable
          label="售卖金额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderNum"
          sortable
          label="关联订单数"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="spuRank.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
    <div class="table" v-if="searchCondition.ruleTimeStrategyType === 'pinPai'">
      <el-table
        ref="table"
        :data="brandRank.records"
        style="width: 100%"
        stripe
        size="small"
        border
        @selection-change="getChecked"
        @sort-change="sortChange"
        :default-sort="{ prop: 'num', order: 'descending' }"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          label="品牌"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="saleNum"
          label="售卖数"
          sortable
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="saleMoney"
          label="售卖金额"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderNum"
          label="关联订单数"
          sortable
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="brandRank.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
    <div
      class="table"
      v-if="searchCondition.ruleTimeStrategyType === 'huiYuan'"
    >
      <el-table
        ref="table"
        :data="memberRank.records"
        style="width: 100%"
        stripe
        size="small"
        border
        @sort-change="sortChange"
        :default-sort="{ prop: 'num', order: 'descending' }"
        @selection-change="getChecked"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="会员名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobile"
          label="电话号码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="consumeTotalMoney"
          label="购买总额"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderNum"
          label="订单数"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberNum"
          label="推荐会员数"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="maxConsumeMoney"
          label="单笔订单最高金额"
          sortable
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="memberRank.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
    <div
      class="table"
      v-if="searchCondition.ruleTimeStrategyType === 'tuiHuiYuan'"
    >
      <el-table
        ref="table"
        :data="pushMemberRank.records"
        style="width: 100%"
        stripe
        size="small"
        border
        @selection-change="getChecked"
        @sort-change="sortChange"
        :default-sort="{ prop: 'num', order: 'descending' }"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="推会员名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobile"
          label="电话号码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="selfMoney"
          label="自购金额"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="selfOrderNum"
          label="自购订单数"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareOrderNum"
          label="分销订单数"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMoney"
          label="分销金额"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnMoney"
          label="返佣"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberNum"
          label="推荐推会员数"
          sortable
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="pushMemberRank.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      sort: {},
      currentPage: 1,
      pageSize: 10,
      isOutputing: false,
      searchCondition: {
        ruleTimeStrategyType: "shangPin",
        applyDate: []
      }
    };
  },
  computed: mapGetters([
    "spuRank",
    "allSpuRank",
    "brandRank",
    "memberRank",
    "pushMemberRank"
  ]),
  watch: {},
  created() {},
  mounted() {
    this.getParamsCookie();
    this.queryList(this.searchCondition.ruleTimeStrategyType);
  },
  methods: {
    queryList(val) {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        order: this.sort.order,
        prop: this.sort.prop
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.setParamsCookie();
      searchCondition.startDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";

      Object.assign(params, searchCondition);
      if (val === "shangPin") {
        return this.$store.dispatch("querySpuRank", params);
      } else if (val === "pinPai") {
        return this.$store.dispatch("queryBrandRank", params);
      } else if (val === "huiYuan") {
        return this.$store.dispatch("queryMemberRank", params);
      } else if (val === "tuiHuiYuan") {
        return this.$store.dispatch("queryPushMemberRank", params);
      }
    },
    setParamsCookie() {
      setCookie({
        key: "rankingListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "rankingListParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryAllList(val) {
      let params = {
        pageSize: 999999,
        pageNo: 1,
        order: this.sort.order,
        prop: this.sort.prop
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.startDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";

      Object.assign(params, searchCondition);
      if (val === "shangPin") {
        return this.$store.dispatch("queryAllSpuRank", params);
      } else if (val === "pinPai") {
        return this.$store.dispatch("queryAllBrandRank", params);
      } else if (val === "huiYuan") {
        return this.$store.dispatch("queryAllMemberRank", params);
      } else if (val === "tuiHuiYuan") {
        return this.$store.dispatch("queryAllPushMemberRank", params);
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList(this.searchCondition.ruleTimeStrategyType);
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList(this.searchCondition.ruleTimeStrategyType);
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryList(this.searchCondition.ruleTimeStrategyType);
    },
    search() {
      this.currentPage = 1;
      this.queryList(this.searchCondition.ruleTimeStrategyType);
    },
    getChecked(selection) {
      // this.checkedRow = selection.map(v => v.orderId);
      if (selection.length > 0) {
        // this.invoiceList.order.records.forEach(v => {
        //   selection.map(x => {
        //     if (v.orderId === x.orderId) {
        //       v.disabled = false;
        //     }
        //   });
        // });
        this.checkedRow = selection;
      } else {
        this.invoiceList.order.records.forEach(v => {
          v.disabled = true;
        });
        this.show = false;
      }
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList(this.searchCondition.ruleTimeStrategyType)
          .then(res => {
            const list = res.result.records;
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label)
              .filter(o => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            let title = "";
            if (this.searchCondition.ruleTimeStrategyType === "shangPin") {
              title = "商品排行";
            } else if (this.searchCondition.ruleTimeStrategyType === "pinPai") {
              title = "品牌排行";
            } else if (
              this.searchCondition.ruleTimeStrategyType === "huiYuan"
            ) {
              title = "会员排行";
            } else if (
              this.searchCondition.ruleTimeStrategyType === "tuiHuiYuan"
            ) {
              title = "推会员排行";
            } else if (
              this.searchCondition.ruleTimeStrategyType === "menDian"
            ) {
              title = "门店排行";
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
